/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCredentialsForAwsAssumeRoleProtocol extends models.ServiceAccountCredentialsBaseForAws {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountCredentialsForAwsAssumeRoleProtocol");
    }

    getFixupPrototypeFunction() { return ServiceAccountCredentialsForAwsAssumeRoleProtocol.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCredentialsForAwsAssumeRoleProtocol>): ServiceAccountCredentialsForAwsAssumeRoleProtocol {
        let obj = Object.assign(new ServiceAccountCredentialsForAwsAssumeRoleProtocol(), model);
        ServiceAccountCredentialsForAwsAssumeRoleProtocol.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCredentialsForAwsAssumeRoleProtocol>): ServiceAccountCredentialsForAwsAssumeRoleProtocol {
        if (!model) return null;
        return ServiceAccountCredentialsForAwsAssumeRoleProtocol.newInstance(<ServiceAccountCredentialsForAwsAssumeRoleProtocol> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCredentialsForAwsAssumeRoleProtocol) {
        if (!obj) return;

        models.ServiceAccountCredentialsForAwsAssumeRoleProtocol.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCredentialsForAwsAssumeRoleProtocol): boolean {
        if (models.ServiceAccountCredentialsBaseForAws.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountCredentialsForAwsAssumeRoleProtocol.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Role ARN. This is a required field.
     */
    assume_role_arn: string;

    /**
     * External ID configured in Assume Role. This is a required field.
     */
    assume_role_external_id: string;

    /**
     * Whether MFA enabled or not in Assume Role. This is a required field.
     */
    assume_role_mfa_enabled: boolean;

    /**
     * Access Key Id to access S3 bucket in which CUR export available.
     */
    s3_access_key: string;

    /**
     * Secret Access Key Id to access S3 bucket in which CUR export is available.
     */
    s3_secret_key: string;

}
